import React from 'react';

import { ReviewScreen } from './ReviewScreen';

/**
 * ReviewPage - Wrapper component for Final Review screen
 * Provides routing and state management for the review functionality
 */
export const ReviewPage: React.FC = () => {
  return <ReviewScreen />;
};
